import { FormErrors } from './FormErrors'
// import { _ } from 'underscore'

export class Form {
    constructor(data) {
        $.extend(this, data)

        this.events = new Vue()
        this.errors = new FormErrors()
        this.resetStatus()
    }

    data() {
        let data = {}
        const ignore = Object.keys(new Form())

        Object.keys(this).forEach(key => {
            if (ignore.indexOf(key) === -1) {
                data[key] = this[key]
            }
        })

        return data
    }

    startProcessing() {
        this.errors.forget()
        this.setState(true, false)
        this.events.$emit('busy')
    }

    finishProcessing() {
        this.setState(false, true)
        this.events.$emit('success')
    }

    resetStatus() {
        this.errors.forget()
        this.setState(false, false)
    }

    setErrors(errors) {
        this.setState(false, this.successful)
        this.errors.set(errors)
        this.events.$emit('failure')
    }

    setState(busy, success) {
        this.busy = busy
        this.successful = success
        this.busyOrSuccessful = busy || success
    }
}
